<template>
    <!-- =========== MAIN ========== -->
    <main id="rooms_list">
        <div class="container">


            <article class="room_list" v-for="restaurant in restaurants">
                <div class="row row-flex">
                    <div class="col-lg-4 col-md-5 col-sm-12">
                        <figure>
                            <router-link v-bind:to="'/site/restaurant/'+restaurant.id" class="hover_effect h_link h_blue">
                                <img v-bind:src="getImage(restaurant)" class="img-responsive" alt="Image">
                            </router-link>
                        </figure>
                    </div>
                    <div class="col-lg-8 col-md-7 col-sm-12">
                        <div class="room_details row-flex">
                            <div class="col-md-9 col-sm-9 col-xs-12 room_desc">
                                <h3>
                                    <router-link v-bind:to="'/site/restaurant/'+restaurant.id" >
                                        {{ restaurant.name[currentLanguage] }}
                                    </router-link>
                                </h3>
                                <p>{{ truncate(restaurant.description[currentLanguage]) }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </article>

        </div>
    </main>
</template>

<script>
    import forEach from 'lodash';
    import DefaultComponent from './Component';
    export default {
        props : DefaultComponent.props,
        methods : DefaultComponent.methods,
        computed : DefaultComponent.computed
    };
</script>


// WEBPACK FOOTER //
// ListView.vue?105f8e78